import { useMemo } from 'react';

export const useFilteredDates = (chartType, data, range) => {
  return useMemo(() => {
    if (!data || !data.length) return [];

    // 获取所有唯一日期并排序
    let dates = [...new Set(data.map((d) => d.date))].sort();

    // 对于特定图表类型，使用不同的过滤逻辑
    if (chartType === "usJobs" || chartType === "trade") {
      return dates.slice(-Math.min(dates.length, Math.ceil(range/30)));
    } 
    
    // 对于不需要日期过滤的图表类型
    if (chartType === "forex" || chartType === "marketShare" || chartType === "chinaPBOC") {
      return dates;
    }

    // 对于需要按时间范围过滤的图表类型（包括 keyAssets）
    if (chartType === "keyAssets" || chartType === "freedom" || 
        ["line", "dualLine", "dualLinePlus"].includes(chartType)) {
      const cutoffDate = new Date();
      cutoffDate.setDate(cutoffDate.getDate() - range);
      return dates.filter((d) => new Date(d) >= cutoffDate);
    }

    // 默认按时间范围过滤
    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - range);
    return dates.filter((d) => new Date(d) >= cutoffDate);
  }, [chartType, data, range]);
};